<template>
  <div id="main-content" >
    <a-form layout="inline" style="background: #ffffff;padding: 10px;margin-bottom: 10px;border-radius: 10px;">
      <a-form-item>
        <a-radio-group button-style="solid" v-model="platform" @change="init_data">
          <a-radio-button value="android">
            Android
          </a-radio-button>
          <a-radio-button value="ios">
            iOS
          </a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item>
        <a-radio-group button-style="solid" v-model="type" @change="init_data">
          <a-radio-button :value="1">
            内购
          </a-radio-button>
          <a-radio-button :value="2">
            订阅
          </a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item>
        <a-select v-model="app_id" style="width: 240px" allowClear showSearch
                  placeholder="请选择产品"
                  optionFilterProp="label"
                  @change="init_data()">
          <a-select-option v-for="productItem in $store.getters.getAppAll"
                           :label="productItem.app_name"
                           :value="productItem.app_id"
                           :key="productItem.app_id">
            <img :src="productItem.icon" style="height: 28px;border-radius: 5px;">
            {{productItem.app_name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-select v-model="country" style="width: 200px" allowClear mode="multiple" :maxTagCount="1" optionFilterProp="label" placeholder="请选择国家" @change="init_data()">
          <a-select-option :key="countryItem.value" :value="countryItem.value"
                           :label="countryItem.name"
                           v-for="countryItem in $store.state.Country">
            {{countryItem.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item style="float: right;margin: 0">
        <a-button type="primary" html-type="submit" >导出</a-button>
      </a-form-item>
      <a-form-item style="float: right">
        <a-range-picker v-model="date"
                        valueFormat="YYYY-MM-DD"
                        style="width: 240px;" @change="init_data()" />
      </a-form-item>
      <a-form-item style="color: red;float: right">
        iOS：唯一时区&nbsp;&nbsp;&nbsp;&nbsp;Android：UTC时区
      </a-form-item>
    </a-form>
    <a-table :columns="getTableColumns" id="show-table"
             style="flex: 1;overflow-y: hidden;background: #ffffff"
             :scroll="{ x: '500px',y: _get_table_scroll({id:'show-table'}) }"
             :loading="tableLoad"
             :data-source="tableData" bordered :pagination="false">
      <span slot="app_id" slot-scope="text" style="cursor: pointer">
        <ApplicationShow :application-list="$store.getters.getAppAll" :app-id="text"></ApplicationShow>
      </span>
    </a-table>
  </div>
</template>

<script>
import ApplicationShow from "../../components/V1/ApplicationShow";
import {GetPurchaseRatio} from "../../api/v1/purchase_api";
export default {
  name: "Ratio",
  components: {ApplicationShow},
  data(){
    return {
      platform:"android",
      app_id:undefined,
      type:1,
      country:[],
      date:['',''],
      tableLoad:false,
      tableData:[],
    }
  },
  computed:{
    getTableColumns(){
      let _table_columns = [
        {title: '产品', width:360, scopedSlots: { customRender: 'app_id' }, dataIndex: 'app_id',align:'left'},
        {title: '国家', scopedSlots: { customRender: 'country' }, dataIndex: 'country',align:'center'},
        {title: '币种', scopedSlots: { customRender: 'currency' }, dataIndex: 'currency',align:'center'},
        {title: '分成比例', scopedSlots: { customRender: 'rate' }, dataIndex: 'rate',align:'center'},
        {title: '结算比例', scopedSlots: { customRender: 'ratio' }, dataIndex: 'ratio',align:'center'},
      ]
      return _table_columns
    }
  },
  mounted() {
    this.init_data()
  },
  methods:{
    init_data(){
      this.tableLoad = true
      GetPurchaseRatio({
        app_id:this.app_id,
        platform:this.platform,
        type:this.type,
        country:this.country.join(","),
        start:this.date[0],
        end:this.date[1],
      }).then(resp => {
        this.tableLoad = false
        if (resp.code===200){
          this.tableData = resp.data
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Purchase/Ratio.vue